export const FETCH_STATISTIC = 'FETCH_STATISTIC';
export const SET_STATISTIC = 'SET_STATISTIC';
export const SET_STATISTIC_MANAGERS_HASH = 'SET_STATISTIC_MANAGERS_HASH';
export const SET_HISTORIES_BY_MANAGER_IDS = 'SET_HISTORIES_BY_MANAGER_IDS';
export const SET_FILTER_STATISTIC = 'SET_FILTER_STATISTIC';
export const SET_COMMUNICATION_COUNTS_BY_MANAGER_IDS =
  'SET_COMMUNICATION_COUNTS_BY_MANAGER_IDS';
export const SET_TIMES_IN_STATUSES_BY_MANAGER_IDS =
  'SET_TIMES_IN_STATUSES_BY_MANAGER_IDS';

export const filter = payload => ({
  payload,
  type: SET_FILTER_STATISTIC,
});

export const refresh = () => ({
  type: FETCH_STATISTIC,
});
